import { Form, Input as AntdInput, Tooltip } from 'antd';
import cn from 'classnames';
import React from 'react';

import Btn from '../../../../../../../../components/btn';
import FilterBtn from '../../../../../../../RoomsAcceptance/shared/ui/FilterBtn';
import Input from '../../../../../../../RoomsAcceptance/shared/ui/Input';
import { FormSection } from '../FormSection';
import { ModeSwitcher } from '../ModeSwitcher';
import { serviceSetFilterFieldNames } from '../../CreateNewWorkScheduleByPeriod.constants';
import { ServiceSetSelectFilter, ServiceSetsFilter } from './ServiceSetFilters';
import { ServiceReasonList } from './ServiceReasonList';
import { ServiceSetSelect } from './ServiceSetSelect';
import { ServiceSetsPreview } from './ServiceSetsPreview';
import { ServiceSetEditorActions } from './ServiceSetEditorActions';
import styles from './ServiceSetsSection.module.scss';
import { createServiceSetNameSearch, validateRequiredArray } from './utils';

export const ServiceSetsSectionView = ({
  collapsedServiceKeys,
  deletingServiceSetId,
  deletingServiceSetPreviewItems,
  editingServiceSet,
  editingServiceSetId,
  filteredSelectedServiceSets,
  filteredServiceReasonGroups,
  form,
  getFieldDecorator,
  hasFilters,
  hasSelectedServiceSets,
  hasVisibleItems,
  hasVisibleSelectedReasons,
  hasVisibleUnselectedReasons,
  isCreateMode,
  isDeleteMode,
  isEditMode,
  isEditable,
  isSubmitDisabled,
  mode,
  modeOptions,
  previewServices,
  createLoading,
  deleteLoading,
  deletingServiceSetDetailsLoading,
  editingServiceSetDetailsLoading,
  reasonsLoading,
  selectedReasonIdSet,
  selectedServiceIdSet,
  selectedServiceFilterOptions,
  selectedServiceSetValue,
  selectedServiceSetValues,
  serviceOptions,
  serviceSetComment,
  serviceSetName,
  serviceSetOptions,
  serviceDetailsLoading,
  servicesLoading,
  sortedServiceSetOptions,
  submitButtonDisabled,
  submitButtonTooltip,
  submitDisabledReason,
  updateLoading,
  searchValue,
  onDeselectAll,
  onDeletingServiceSetChange,
  onDeleteSubmit,
  onEditingServiceSetChange,
  onModeChange,
  onReasonClick,
  onSearchChange,
  onSelectAll,
  onServiceClick,
  onServiceCollapseToggle,
  onServiceSetCommentBlur,
  onServiceSetCommentChange,
  onServiceSetNameBlur,
  onServiceSetNameChange,
  onServiceSetsChange,
  onSubmit,
  onCancel,
}) => (
  <FormSection
    title="Набор услуг"
    headerClassName={cn(styles.serviceSetHeader, {
      [styles.serviceSetEditorHeader]: isCreateMode || isEditMode,
    })}
    actions={
      <div className={styles.serviceSetHeaderActions}>
        <ModeSwitcher
          disabled={
            !isEditable ||
            isEditMode ||
            createLoading ||
            updateLoading ||
            deleteLoading
          }
          lockInactive={isCreateMode || isEditMode}
          options={modeOptions}
          value={mode}
          onChange={onModeChange}
        />
        {(isCreateMode || isEditMode) && (
          <ServiceSetEditorActions
            isSaving={createLoading || updateLoading}
            previewServices={previewServices}
            serviceSetName={serviceSetName}
            serviceSetComment={serviceSetComment}
            submitButtonDisabled={submitButtonDisabled}
            submitButtonTooltip={submitButtonTooltip}
            onCancel={onCancel}
            onSubmit={onSubmit}
          />
        )}
      </div>
    }
  >
    <div className={styles.hiddenField}>
      {getFieldDecorator('serviceSetIds', {
        initialValue: selectedServiceSetValues,
        rules: [
          {
            validator: validateRequiredArray('Выберите набор услуг'),
          },
        ],
      })(<input id="serviceSetIds" name="serviceSetIds" type="hidden" />)}
      {getFieldDecorator('newServiceSetName', {
        initialValue: '',
      })(
        <input id="newServiceSetName" name="newServiceSetName" type="hidden" />
      )}
      {getFieldDecorator('newServiceSetComment', {
        initialValue: '',
      })(
        <input
          id="newServiceSetComment"
          name="newServiceSetComment"
          type="hidden"
        />
      )}
      {getFieldDecorator('newServiceSetReasonIds', {
        initialValue: [],
      })(
        <input
          id="newServiceSetReasonIds"
          name="newServiceSetReasonIds"
          type="hidden"
        />
      )}
      {getFieldDecorator(serviceSetFilterFieldNames.service, {
        initialValue: [],
      })(
        <input
          id={serviceSetFilterFieldNames.service}
          name={serviceSetFilterFieldNames.service}
          type="hidden"
        />
      )}
      {getFieldDecorator(serviceSetFilterFieldNames.immediate, {
        initialValue: false,
      })(
        <input
          id={serviceSetFilterFieldNames.immediate}
          name={serviceSetFilterFieldNames.immediate}
          type="hidden"
        />
      )}
      {getFieldDecorator(serviceSetFilterFieldNames.selection, {
        initialValue: '',
      })(
        <input
          id={serviceSetFilterFieldNames.selection}
          name={serviceSetFilterFieldNames.selection}
          type="hidden"
        />
      )}
    </div>
    <div
      className={styles.serviceSetGrid}
      onKeyDown={(event) => {
        if (
          (isCreateMode || isEditMode) &&
          event.key === 'Enter' &&
          event.target.tagName === 'INPUT'
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      {isDeleteMode ? (
        <div className={styles.serviceSetCreator}>
          <Form.Item label="Набор для удаления" className={styles.formItem}>
            <ServiceSetSelect
              options={sortedServiceSetOptions}
              disabled={!isEditable || deleteLoading}
              id="deletingServiceSetId"
              name="deletingServiceSetId"
              placeholder="Выберите набор услуг"
              value={deletingServiceSetId}
              onChange={onDeletingServiceSetChange}
            />
          </Form.Item>
          <ServiceSetsPreview
            className={styles.serviceSetInlinePreview}
            serviceSets={deletingServiceSetPreviewItems}
            isLoading={deletingServiceSetDetailsLoading}
            emptyText={
              deletingServiceSetId
                ? 'В выбранном наборе нет услуг'
                : 'Выберите набор услуг'
            }
          />
          <div>
            <Tooltip title={deletingServiceSetId ? '' : 'Выберите набор услуг'}>
              <span className={styles.disabledButtonWrapper}>
                <Btn
                  disabled={
                    !isEditable || !deletingServiceSetId || deleteLoading
                  }
                  icon="delete"
                  className={cn(styles.addButton, styles.deleteButton, {
                    [styles.addButtonDisabled]:
                      !isEditable || !deletingServiceSetId || deleteLoading,
                  })}
                  onClick={onDeleteSubmit}
                >
                  Удалить набор
                </Btn>
              </span>
            </Tooltip>
          </div>
        </div>
      ) : !isCreateMode && !isEditMode ? (
        <div className={styles.serviceSetSelectBlock}>
          <div className={styles.serviceSetSelectRow}>
            <Form.Item label="Существующий набор" className={styles.formItem}>
              <ServiceSetSelect
                className={styles.dropdownSelect}
                createSearch={createServiceSetNameSearch}
                options={sortedServiceSetOptions}
                disabled={!isEditable}
                id="selectedServiceSetId"
                name="selectedServiceSetId"
                showSearch
                value={selectedServiceSetValue}
                onSelectedChange={onServiceSetsChange}
                label="Набор услуг"
              />
            </Form.Item>
            <Tooltip
              title={hasSelectedServiceSets ? '' : 'Выберите набор услуг'}
            >
              <span className={styles.disabledButtonWrapper}>
                <FilterBtn
                  disabled={!isEditable || !hasSelectedServiceSets}
                  isActive={hasFilters}
                  renderContent={({ onClose }) => (
                    <ServiceSetSelectFilter
                      form={form}
                      isEditable={isEditable}
                      serviceOptions={selectedServiceFilterOptions}
                      onClose={onClose}
                    />
                  )}
                />
              </span>
            </Tooltip>
          </div>
          <ServiceSetsPreview
            className={styles.serviceSetInlinePreview}
            serviceSets={filteredSelectedServiceSets}
            isLoading={serviceDetailsLoading}
            emptyText={
              hasSelectedServiceSets
                ? 'В выбранном наборе нет услуг по фильтру'
                : 'Выберите набор услуг'
            }
          />
        </div>
      ) : (
        <div className={styles.serviceSetCreator}>
          {isEditMode && (
            <Form.Item label="Набор для изменения" className={styles.formItem}>
              <ServiceSetSelect
                options={serviceSetOptions}
                disabled={!isEditable || updateLoading}
                id="editingServiceSetId"
                name="editingServiceSetId"
                placeholder="Выберите набор услуг"
                value={editingServiceSetId}
                onChange={onEditingServiceSetChange}
              />
            </Form.Item>
          )}
          {(!isEditMode || editingServiceSet) && (
            <>
              <Form.Item
                label="Наименование набора"
                className={styles.formItem}
              >
                <AntdInput
                  className={styles.textField}
                  disabled={!isEditable || createLoading || updateLoading}
                  id="newServiceSetNameInput"
                  name="newServiceSetNameInput"
                  placeholder="Введите наименование"
                  value={serviceSetName}
                  onChange={onServiceSetNameChange}
                  onBlur={onServiceSetNameBlur}
                />
              </Form.Item>
              <Form.Item
                label="Комментарий"
                htmlFor="newServiceSetCommentInput"
                className={styles.formItem}
              >
                <AntdInput.TextArea
                  className={cn(styles.textField, styles.commentField)}
                  disabled={!isEditable || createLoading || updateLoading}
                  id="newServiceSetCommentInput"
                  name="newServiceSetCommentInput"
                  placeholder="Введите комментарий (необязательно)"
                  autoSize={{ minRows: 2, maxRows: 5 }}
                  value={serviceSetComment}
                  onChange={onServiceSetCommentChange}
                  onBlur={onServiceSetCommentBlur}
                />
              </Form.Item>
              <div className={styles.serviceReasonToolbar}>
                <Input
                  className={styles.workerSearch}
                  disabled={
                    servicesLoading ||
                    reasonsLoading ||
                    editingServiceSetDetailsLoading
                  }
                  id="serviceReasonSearch"
                  name="serviceReasonSearch"
                  placeholder="Поиск услуги или причины"
                  type={Input.types.search}
                  value={searchValue}
                  onChange={onSearchChange}
                />
                <FilterBtn
                  isActive={hasFilters}
                  renderContent={({ onClose }) => (
                    <ServiceSetsFilter
                      form={form}
                      isEditable={isEditable}
                      serviceOptions={serviceOptions}
                      servicesLoading={servicesLoading}
                      onClose={onClose}
                    />
                  )}
                />
              </div>
              {hasVisibleItems && (
                <div className={styles.workerBulkActions}>
                  <button
                    type="button"
                    className={styles.workerBulkButton}
                    disabled={!isEditable || !hasVisibleUnselectedReasons}
                    onClick={onSelectAll}
                  >
                    Выбрать все
                  </button>
                  <button
                    type="button"
                    className={styles.workerBulkButton}
                    disabled={!isEditable || !hasVisibleSelectedReasons}
                    onClick={onDeselectAll}
                  >
                    Снять все
                  </button>
                </div>
              )}
              <ServiceReasonList
                collapsedServiceKeys={collapsedServiceKeys}
                filteredServiceReasonGroups={filteredServiceReasonGroups}
                isEditable={isEditable}
                reasonsLoading={
                  reasonsLoading || editingServiceSetDetailsLoading
                }
                selectedReasonIdSet={selectedReasonIdSet}
                selectedServiceIdSet={selectedServiceIdSet}
                servicesLoading={servicesLoading}
                onReasonToggle={onReasonClick}
                onServiceCollapseToggle={onServiceCollapseToggle}
                onServiceToggle={onServiceClick}
              />
              <div>
                {isSubmitDisabled && (
                  <div className={styles.serviceSetDisabledReason}>
                    {submitDisabledReason}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  </FormSection>
);
